import { Injectable } from '@angular/core';
import { Papa } from 'ngx-papaparse';

@Injectable({
  providedIn: 'root',
})
export class CsvToJsonService {
  constructor(private _papa: Papa) {}

  public async csvToJson(file: File) {
    return new Promise((resolve, reject) => {
      const data = this._papa.parse(file, {
        complete: (result) => {
          return resolve(result.data);
        },
      });
    });
  }
}
